import ColourSelector from '../../../../atoms/ColourSelector/ColourSelector';
import Accordion from '../../../Accordion/Accordion';
import StyledColorFragment from './styles';
import Props from './typings';

const colors = [
  '000000',
  '7d533f',
  'd10d12',
  'e67201',
  'fed720',
  'cc3399',
  '1b299c',
  '6b95e7',
  '96d8e0',
  '0a4c24',
  '608622',
  'b7b7b7',
  'dec6b4',
  'ffffff',
];

export const getColourTiltle = (selectedColors) => {
  return {label: selectedColors, count: selectedColors.length > 0 ? 1 : 0};
};

const Colour = ({
  selected,
  colourCallback,
  collapsible = false,
  defaultCollapsed = false,
}: Props) => {
  const title = 'Colour';
  const subtitle = 'Pick a colour, any colour.';

  const onColorClick = (color) => {
    let callbackArray = [...selected];
    if (callbackArray.includes(color)) {
      callbackArray = callbackArray.filter((hex) => hex !== color);
    } else {
      callbackArray.push(color);
    }
    colourCallback(callbackArray);
  };

  const fragmentBody = () => (
    <ColourSelector selected={selected} colorArray={colors} callback={onColorClick} />
  );

  const collapsibleFragment = () => (
    <Accordion title={title} subtitle={subtitle} defaultCollapsed={defaultCollapsed}>
      {fragmentBody()}
    </Accordion>
  );

  const fragment = () => (
    <StyledColorFragment>
      <h4>{title}</h4>

      <p>{subtitle}</p>

      {fragmentBody()}
    </StyledColorFragment>
  );
  return collapsible === true ? collapsibleFragment() : fragment();
};

export default Colour;
